import Modal from "react-modal";
import React, { useState } from "react";
import * as S from "./styles";
import Input from "../../Input";
import { getMaintenanceReportsToExcel, getReports, getReportsToExcel } from "services/ReportServices";
import { fireAlert, fireToast } from "services/sweetAlertConfig";
import { ReactComponent as CloseIcon } from "assets/close-small.svg";
import { parseDate } from "utils/parseDate";
import { Flex } from "monk_ui";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

Modal.setAppElement("#root");

export default function ExportReportModal({
  modalIsOpen,
  setIsOpen,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }
  const [start, setStart] = useState<Date>();
  const [finish, setFinish] = useState<Date>();
  const [requesting, setRequesting] = useState<boolean>(false);



  function requestReport() {
    setRequesting(true);

    getMaintenanceReportsToExcel({
      start,
      finish,
    })
      .then((res) => {
        const fileURL = URL.createObjectURL(res.data);
        const link = document.createElement("a");

        link.href = fileURL;
        link.setAttribute("download", `reports.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(fileURL);
        setRequesting(false);
        fireToast("arquivo gerado com sucesso");
      })
      .catch((err) => {
        fireAlert("error", "Aconteceu um erro");
        console.log({ err });
        setRequesting(false);
      });
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveContent {...props}>{children}</S.ActiveContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveOverlay {...props}>{contentElement}</S.ActiveOverlay>
      )}
    >
      <S.Content>
        <Flex alignItems="center" justifyContent="flex-end" height="1.875rem">
          <CloseIcon style={{ cursor: "pointer" }} onClick={closeModal} />
        </Flex>

        <h2>Exportar relatório</h2>
        <p>
          Escolha a data de começo e fim para gerar o relatório durante o
          período. (Não escolher datas irá gerar um relatório dos últimos 30
          dias.)
        </p>

        <S.Row>
          <S.Column>
            <Input
              id="start"
              name="start"
              required
              type="Date"
              label="Data Inicial"
              onChange={(e) => {
                parseDate(setStart, e.target.value);
              }}
            />
            <Input
              id="finish"
              name="finish"
              required
              type="Date"
              label="Data Final"
              onChange={(e) => {
                parseDate(setFinish, e.target.value);
              }}
            />

          </S.Column>
        </S.Row>
        <S.ActiveConfirmButton
          disabled={requesting}
          onClick={() => requestReport()}
          type="button"
        >
          Gerar relatório
        </S.ActiveConfirmButton>
      </S.Content>
    </Modal>
  );
}
